import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { MaterialRowsTable, UnmatchedList } from "../components/OrderMaterialsModal";
import { SkuMatcherPanel } from "../components/SkuMatcher";
import { ReceiveGoodsButton, LowStockCard } from "../components/ReceiveGoods";
import { NewPurchaseOrderButton } from "../components/PurchaseOrders";
import { RefreshCw } from "lucide-react";

const Stat = ({ label, value, testId }) => (
  <div className="card-dark p-5" data-testid={testId}>
    <div className="label-caps mb-2">{label}</div>
    <div className="h-editorial text-3xl">{value}</div>
  </div>
);

export default function MaterialNeedsPage() {
  const [data, setData] = useState(null);
  const [onlyMissing, setOnlyMissing] = useState(false);
  const load = () => api.get("/materials/requirements").then(r => setData(r.data));
  useEffect(() => { load(); }, []);
  if (!data) return <div className="text-sm opacity-60">Calcolo in corso…</div>;
  const rows = onlyMissing ? data.rows.filter(r => (r.to_order ?? r.missing) > 0) : data.rows;
  return (
    <div data-testid="material-needs-page">
      <p className="text-sm opacity-70 mb-6 max-w-3xl">
        Somma dei materiali che servono per tutti gli ordini aperti (Bozza, Preventivo, Confermato, In produzione).
        Gli ordini Confermati o In produzione tengono i materiali riservati; quando un ordine passa a Pronto, Spedito o Completato
        i materiali vengono scaricati dal magazzino.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <Stat label="Ordini aperti" value={data.orders_count} testId="needs-orders-count"/>
        <Stat label="Materiali da ordinare" value={data.missing_count} testId="needs-missing-count"/>
        <Stat label="Costo stimato acquisti" value={`€ ${data.to_order_cost.toLocaleString("it-IT", { minimumFractionDigits: 2 })}`} testId="needs-cost"/>
      </div>
      <SkuMatcherPanel onChange={load}/>
      <LowStockCard refreshKey={data}/>
      <div className="flex items-center gap-4 mb-4">
        <ReceiveGoodsButton onDone={load}/>
        <NewPurchaseOrderButton onDone={load}/>
        <label className="text-xs uppercase tracking-widest inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" data-testid="needs-only-missing" checked={onlyMissing} onChange={e => setOnlyMissing(e.target.checked)}/> Solo da ordinare
        </label>
        <button data-testid="needs-refresh" onClick={load} className="text-xs uppercase tracking-widest inline-flex items-center gap-2 opacity-70 hover:opacity-100"><RefreshCw size={12}/> Aggiorna</button>
      </div>
      {rows.length ? <MaterialRowsTable rows={rows} testPrefix="needs" showReserved/> :
        <div className="text-sm opacity-60 p-10 border border-dashed text-center" data-testid="needs-empty">Nessun materiale da mostrare.</div>}
      <UnmatchedList items={data.unmatched.filter(u => u.reason !== "no_garment")} testId="needs-unmatched"/>
    </div>
  );
}
